import { ApplyJobPayload } from "../../../models/Job";
import { getApiInstance } from "../../api";
import ApiClient from "../../apiClient";
import mutationWrapper from "../mutationWrapper";

export async function ApplyJob(data: ApplyJobPayload): Promise<any> {
  const res = await ApiClient.post(`/ApplyJob`, data);
  return res.data;
}

export const useApplyJob = mutationWrapper(ApplyJob);
